// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"38824f69","182":"b6738707","205":"574fe3bf","403":"466bec36","508":"19343943","551":"3f6e3e9a","629":"a6fc9f5f","873":"c9b6a126"}[chunkId] + ".chunk.js";
};